var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('MainPage',{attrs:{"settings":this.settings,"hardReset":this.reset,"game":this.game}}),_c('IntroBox',{directives:[{name:"show",rawName:"v-show",value:(this.showIntro),expression:"this.showIntro"}],attrs:{"close":function () { return this$1.close(); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }